import { isEmptyFilter } from "../../hooks/useFilters";

export function useFilterEmptyWorkflows() {
  return (filters, updatedSlicedFilter) => {
    const filterEmptyWorkflows = (isPrevFilterEmpty, isCurFilterEmpty) => {
      return isPrevFilterEmpty === isCurFilterEmpty
        ? {}
        : { filterEmptyWorkflows: Boolean(isPrevFilterEmpty) };
    };

    return filterEmptyWorkflows(
      isEmptyFilter(filters, true),
      isEmptyFilter({ ...filters, ...updatedSlicedFilter }, true)
    );
  };
}
export default useFilterEmptyWorkflows;
